import React, { useCallback, useEffect, useRef, useState } from 'react';
import styles from 'components/hireUsButton/hireUsButton.module.css';
import { useTranslation } from 'react-i18next';

import { VelvetyWebSpinningText } from 'components/vectors/VelvetyWebSpinningText';
import { throttle } from 'utils/throttle.utils';
import { useGetButtonFontSize } from './hireUsButton.hooks';
import { Link } from 'react-scroll';

interface ISection {
    id: string;
    backgroundColor: string;
}

const HireUsButton = () => {
    const blackRgba = 'rgba(0, 0, 0, 0)';
    const whiteColor = 'white';
    const blackColor = 'black';

    const buttonFontSize = useGetButtonFontSize();
    const { t } = useTranslation();
    const [buttonColor, setButtonColor] = useState(whiteColor);
    const currentSectionRef = useRef<ISection | null>(null);

    const handleScroll = useCallback(() => {
        const buttonMarginBottom = 20;
        const buttonHalfHeight = 90;

        const buttonPosition =
            window.innerHeight -
            buttonMarginBottom -
            buttonHalfHeight +
            window.scrollY;

        const sections = document.getElementsByTagName('section');

        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        for (const section of sections) {
            const rect = section.getBoundingClientRect();
            const absoluteTop = window.scrollY + rect.top;
            const absoluteBottom = absoluteTop + rect.height;

            const isWorksSection =
                section.getAttribute('id') === 'section-works';

            const isButtonInSection =
                buttonPosition >= absoluteTop &&
                buttonPosition <= absoluteBottom;

            if (isButtonInSection) {
                const bgColor =
                    window.getComputedStyle(section).backgroundColor;

                const isNewSectionDifferent =
                    !currentSectionRef.current ||
                    currentSectionRef.current.id !== section.id ||
                    currentSectionRef.current.backgroundColor !== bgColor;

                if (isNewSectionDifferent) {
                    currentSectionRef.current = {
                        id: section.id,
                        backgroundColor: bgColor,
                    };

                    const newButtonColor =
                        isWorksSection || bgColor !== blackRgba
                            ? blackColor
                            : whiteColor;

                    setButtonColor(newButtonColor);
                    break;
                }
            }
        }
    }, []);

    const throttledHandleScroll = throttle(handleScroll, 100);

    useEffect(() => {
        window.addEventListener('scroll', throttledHandleScroll);
        return () =>
            window.removeEventListener('scroll', throttledHandleScroll);
    }, [throttledHandleScroll]);

    return (
        <div className={styles.hireUsBtnBox}>
            <Link
                className={styles.visibilityWrapper}
                to="contact"
                smooth={true}
                duration={800}
                spy={true}
                offset={-87}
            >
                <button
                    className={styles.button}
                    style={{ color: buttonColor }}
                >
                    <div
                        className={styles.buttonInner}
                        style={{ fontSize: buttonFontSize }}
                    >
                        {t('hireUsButton.hireUsText')}
                    </div>
                    <VelvetyWebSpinningText fill={buttonColor} />
                </button>
            </Link>
        </div>
    );
};

export default HireUsButton;
